import React from 'react';
import { Monitor, Projector, Cable, SquarePen, ArrowRight } from 'lucide-react';

const FeatureIcon = ({ Icon, available }) => (
  <div className={`p-1.5 rounded-lg ${available ? 'text-gray-300 bg-white/5' : 'text-gray-700 bg-white/5 opacity-30'}`}>
    <Icon size={14} />
  </div>
);

const ClassroomTable = ({ rooms, getRoomStatus, building, navigate }) => {
  return (
    <div className="space-y-3">
      {rooms.map((room) => {
        const status = getRoomStatus(room.id);
        const info = room.information || {};
        
        // Define status styles
        const statusStyles = {
          green: 'bg-green-500/10 text-green-400 border-green-500/20',
          red: 'bg-red-500/10 text-red-400 border-red-500/20',
          yellow: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
          gray: 'bg-gray-500/10 text-gray-400 border-gray-500/20'
        };
        const currentStatusStyle = statusStyles[status.color] || statusStyles.gray;

        return (
          <div
            key={room.id}
            onClick={() => navigate(`/room/${building}/${encodeURIComponent(room.room)}`)}
            className="group bg-[#111] hover:bg-[#161616] border border-white/5 hover:border-white/10 rounded-xl p-4 transition-all duration-200 cursor-pointer"
          >
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
              
              {/* Left: Room Info */}
              <div className="flex items-start justify-between sm:justify-start sm:items-center gap-4 flex-1">
                <div>
                  <h3 className="text-lg font-bold text-white group-hover:text-purple-400 transition-colors">
                    {room.room}
                  </h3>
                  {/* Features tags */}
                  {room.features && room.features.length > 0 && (
                    <div className="flex flex-wrap gap-2 mt-1.5">
                      {room.features.slice(0, 3).map((feature) => (
                        <span key={feature} className="text-xs text-gray-500 font-medium">
                          {feature}
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                {/* Mobile Status Badge */}
                <div className={`sm:hidden px-3 py-1 rounded-full text-xs font-medium border ${currentStatusStyle}`}>
                  {status.text}
                </div>
              </div>

              {/* Right: Status & Tech */}
              <div className="flex items-center justify-between sm:justify-end gap-6 flex-1">
                {/* Tech Icons */}
                <div className="flex gap-2">
                  <FeatureIcon Icon={Monitor} available={info.pc === 'yes'} />
                  <FeatureIcon Icon={Projector} available={info.projector === 'yes'} />
                  <FeatureIcon Icon={Cable} available={info.av_inputs === 'yes'} />
                  <FeatureIcon Icon={SquarePen} available={info.whiteboard === 'yes'} />
                </div>

                {/* Desktop Status Badge */}
                <div className={`hidden sm:block px-3 py-1.5 rounded-full text-xs font-medium border ${currentStatusStyle} min-w-[140px] text-center`}>
                  {status.text}
                </div>

                {/* Arrow */}
                <ArrowRight className="w-5 h-5 text-gray-700 group-hover:text-white transition-colors" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ClassroomTable;